export default __webpack_public_path__ + "static/media/CAPABILITY_CASTING.cd99e2ce.png";